/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const resizeCornerNE = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M7 18h4.5v1.5h-7v-7H6V17L17 6h-4.5V4.5h7v7H18V7L7 18Z" />
	</SVG>
);

export default resizeCornerNE;
